import { connect, MapStateToProps } from 'react-redux';
import { Props } from './CorePrice';
import {
  getPickerMode,
  getPackageConfig,
  getSale,
  getPackageProducts,
  getCurrentCoreSubscriptionV3,
} from '../../../redux/packagePicker/selectors';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';

export type StateProps = Pick<
  Props,
  | 'packageProducts'
  | 'pickerMode'
  | 'alreadyHasSubscription'
  | 'currentCoreSubscription'
  | 'sale'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
  packageProducts: getPackageProducts(state) || [],
  pickerMode: getPickerMode(state) || 'buy',
  packageConfig: getPackageConfig(state),
  alreadyHasSubscription:
    getPickerMode(state) === 'gift' ? false : getCurrentUserHasCore(state),
  currentCoreSubscription: getCurrentCoreSubscriptionV3(state),
  sale: getSale(state),
});

export default connect(mapStateToProps);
